// Shared category -> lucide-react icon name mapping for shipment request
// tiles (CargoTag). Single source so Dashboard's Home tiles and MyRequests'
// tiles never drift the way the old per-file airline-code maps did.
export const CATEGORY_ICONS = {
  'Electronics': 'Smartphone',
  'Clothing & Fashion': 'Shirt',
  'Cosmetics & Beauty': 'Sparkles',
  'Food & Beverages': 'UtensilsCrossed',
  'Books & Stationery': 'BookOpen',
  'Toys & Games': 'Gamepad2',
  'Medical & Pharmacy': 'Pill',
  'Jewelry & Accessories': 'Gem',
  'Sports & Fitness': 'Dumbbell',
  'Home & Living': 'Home',
  'Documents': 'FileText',
  'Other': 'Package',
};
